// Bundle entry: loads the components every page needs (they register themselves on window.Components), then the app.
// Order matters. Built into dist/portal.js by tools/build-portal.js. Rarely needed components live in ui-main.js, extra-main.js,
// media-main.js and editor-main.js and load on demand (components/LazyComponents.js lists their names).
import './components/theme.js';
import './components/EditMode.js';
import './components/Icon.js';
import './components/Button.js';
import './components/IconButton.js';
import './components/Avatar.js';
import './components/Card.js';
import './components/ImageGrid.js';
import './components/Chip.js';
import './components/Progress.js';
import './components/Divider.js';
import './components/Tooltip.js';
import './components/Switch.js';
import './components/Checkbox.js';
import './components/Banner.js';
import './components/IconTile.js';
import './components/SurfaceCard.js';
import './components/Toolbar.js';
import './components/NavMenu.js';
import './components/NavigationBar.js';
import './components/Navbar.js';
import './components/PortfolioPageHeader.js';
import './components/VideoBlock.js';
import './components/FileBlock.js';
import './components/ExtraBlocks.js';
import './components/weatherIconData.js';
import './components/Widgets.js';
import './components/CaseImage.js';
import './components/SiteFonts.js';
import './components/OnThisPage.js';
import './components/CaseStudyPage.js';
import './components/FeatureCard.js';
import './components/SectionShowcase.js';
import './components/portfolioApi.js';
import './components/ImageCarousel.js';
import './components/Consent.js';
import './components/SwitchField.js';
import './components/SegmentedButton.js';
import './components/LabelPills.js';
import './components/FilterMenu.js';
import './components/BlogFinder.js';
import './components/UxWorkspace.js';
import './components/Doodle.js';
import './components/DoodleBackdrop.js';
import './components/PortfolioHero.js';
import './components/links.js';
import './components/SiteFooter.js';
import './components/Fab.js'; // every page shows a FAB (accessibility button), so it is not in the lazy ui bundle
import './components/SiteFabs.js';
import './components/AccessibilityFab.js';
import './components/StudyPicker.js';
import './components/PortfolioHub.js';
import './components/index.js';
import './components/LazyComponents.js';
import './components/AppShell.js';
import './imageGuard.js';
import './track.js';
import './app.js';
